module.exports = __webpack_public_path__ + "static/feitx-4d33825593fefb45cc25df9461478af9.png";